import './LenderList.scss';
import Component from './LenderList.js';
export default Component;